import { render, staticRenderFns } from "./MirrorTextMarkup.vue?vue&type=template&id=957e7556&scoped=true&"
import script from "./MirrorTextMarkup.vue?vue&type=script&lang=js&"
export * from "./MirrorTextMarkup.vue?vue&type=script&lang=js&"
import style0 from "./MirrorTextMarkup.vue?vue&type=style&index=0&id=957e7556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957e7556",
  null
  
)

export default component.exports